module.exports = __webpack_public_path__ + "static/media/arrow_down.fcdabdf8.svg";